import { useContext } from 'react'
import { DocumentUploadContext } from './DocumentUploadProvider'

const useQuoteUpload = () => {
  const context = useContext(DocumentUploadContext)

  if (context === undefined) throw new Error('must be used within DocumentUploadProvider')

  return context
}

export default useQuoteUpload
